/* Bline v3: kleur wisselen, aantal, extra hoes, galerij en in de winkelwagen. */
(function () {
  'use strict';
  function geld(c) {
    var e = Math.floor(c / 100), ct = String(c % 100).padStart(2, '0');
    return '€' + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + ct;
  }

  function meet(naam, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(naam, data || {}); } catch (e) {}
  }

  function Galerij(el) {
    var track = el.querySelector('[data-b3-track]');
    var duims = el.querySelectorAll('.b3-gal__stip i, .b3-gal__duim');
    el.querySelectorAll('[data-b3-naar]').forEach(function (d) {
      d.addEventListener('click', function () {
        var i = Number(d.getAttribute('data-b3-naar'));
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
    var nu = el.querySelector('[data-b3-nu]');
    function index() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function zet() {
      var i = index();
      if (nu) nu.textContent = i + 1;
      el.querySelectorAll('.b3-gal__stip i').forEach(function (d, j) { d.classList.toggle('is-actief', i === j); });
      el.querySelectorAll('.b3-gal__duim').forEach(function (d, j) { d.classList.toggle('is-actief', i === j); });
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(zet, 60); }, { passive: true });
    // Tik of klik op een foto: vergroot op volledig scherm (Clarity 23-10: dode klikken op de hoofdfoto)
    track.addEventListener('click', function (e) {
      var img = e.target.closest('.b3-gal__slide img');
      if (!img || e.target.closest('a, button, video')) return;
      var slides = [].slice.call(track.querySelectorAll('.b3-gal__slide'));
      var fotos = [], start = 0;
      slides.forEach(function (s) {
        var i = s.querySelector('img');
        if (!i || s.querySelector('video')) return;
        if (i === img) start = fotos.length;
        fotos.push({ klein: i.currentSrc || i.src, src: groot(i), alt: i.getAttribute('alt') || '' });
      });
      Zoom.open(fotos, start);
      meet('bline_foto_vergroot', { foto: start + 1 });
    });
    // Scherpe versie alvast ophalen zodra iemand de foto aanraakt of aanwijst
    var vooraf = function (e) {
      var img = e.target.closest && e.target.closest('.b3-gal__slide img');
      if (img) laad(groot(img));
    };
    track.addEventListener('pointerdown', vooraf, { passive: true });
    track.addEventListener('pointerover', vooraf, { passive: true });
    return { reset: function () { track.scrollLeft = 0; zet(); } };
  }

  // Zo breed als het scherm echt nodig heeft (telefoon ~1200, laptop ~900-1800), niet groter
  function groot(img) {
    var s = img.currentSrc || img.src;
    var w = Math.min(window.innerWidth, window.innerHeight) * (window.devicePixelRatio || 1);
    w = Math.max(800, Math.min(2000, Math.ceil(w / 100) * 100));
    return /[?&]width=\d+/.test(s) ? s.replace(/([?&]width=)\d+/, '$1' + w) : s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var geladen = {};
  function laad(src, klaar) {
    if (geladen[src] === true) { if (klaar) klaar(); return; }
    var p = geladen[src] || (geladen[src] = new Image());
    if (klaar) p.addEventListener('load', klaar);
    p.addEventListener('load', function () { geladen[src] = true; });
    if (!p.src) { p.decoding = 'async'; p.src = src; }
  }

  var Zoom = (function () {
    var el, track, teller, vorige, terugFocus, open = false;
    function bouw() {
      el = document.createElement('div');
      el.className = 'b3-zoom';
      el.hidden = true;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', "Foto's vergroot");
      el.innerHTML = '<div class="b3-zoom__track" data-zoom-track></div>' +
        '<button type="button" class="b3-zoom__knop b3-zoom__dicht" data-zoom-dicht aria-label="Sluiten">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '<button type="button" class="b3-zoom__knop b3-zoom__pijl b3-zoom__pijl--l" data-zoom-stap="-1" aria-label="Vorige foto">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<button type="button" class="b3-zoom__knop b3-zoom__pijl b3-zoom__pijl--r" data-zoom-stap="1" aria-label="Volgende foto">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<p class="b3-zoom__teller" data-zoom-teller aria-live="polite"></p>';
      document.body.appendChild(el);
      track = el.querySelector('[data-zoom-track]');
      teller = el.querySelector('[data-zoom-teller]');
      el.querySelector('[data-zoom-dicht]').addEventListener('click', dicht);
      el.querySelectorAll('[data-zoom-stap]').forEach(function (b) {
        b.addEventListener('click', function () { naar(index() + Number(b.getAttribute('data-zoom-stap'))); });
      });
      // klik naast de foto sluit
      el.addEventListener('click', function (e) { if (!e.target.closest('img, button')) dicht(); });
      var tt;
      track.addEventListener('scroll', function () { clearTimeout(tt); tt = setTimeout(tel, 60); }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (!open) return;
        if (e.key === 'Escape') { e.preventDefault(); dicht(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); naar(index() + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); naar(index() - 1); }
        else if (e.key === 'Tab') { // focus binnen het venster houden
          var k = [].slice.call(el.querySelectorAll('button:not([hidden])'));
          var i = k.indexOf(document.activeElement);
          e.preventDefault();
          k[(i + (e.shiftKey ? -1 : 1) + k.length) % k.length].focus();
        }
      });
    }
    function aantal() { return track.children.length; }
    function index() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    // Toon eerst de foto die al op de pagina geladen is; wissel naar de scherpe versie zodra die binnen is
    function scherp(i) {
      var im = track.children[i] && track.children[i].querySelector('img');
      if (!im || !im.getAttribute('data-groot')) return;
      var g = im.getAttribute('data-groot');
      im.removeAttribute('data-groot');
      laad(g, function () { if (im.isConnected) im.src = g; });
    }
    function tel() {
      var i = index(), n = aantal();
      scherp(i); scherp(i + 1); scherp(i - 1);
      teller.textContent = n > 1 ? (i + 1) + ' / ' + n : '';
      el.querySelector('[data-zoom-stap="-1"]').hidden = n < 2 || i === 0;
      el.querySelector('[data-zoom-stap="1"]').hidden = n < 2 || i === n - 1;
    }
    function naar(i) {
      i = Math.max(0, Math.min(aantal() - 1, i));
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }
    function dicht() {
      if (!open) return;
      open = false;
      el.hidden = true;
      document.documentElement.style.overflow = vorige;
      track.innerHTML = '';
      if (terugFocus && terugFocus.focus) terugFocus.focus();
    }
    return {
      open: function (fotos, start) {
        if (!fotos.length) return;
        if (!el) bouw();
        terugFocus = document.activeElement;
        track.innerHTML = fotos.map(function (f, i) {
          var direct = geladen[f.src] === true || !f.klein;
          return '<figure class="b3-zoom__foto"><img src="' + (direct ? f.src : f.klein) + '"' +
            (direct ? '' : ' data-groot="' + f.src + '"') + ' alt="' + f.alt.replace(/"/g, '&quot;') + '"' +
            (Math.abs(i - start) > 1 ? ' loading="lazy"' : '') + '></figure>';
        }).join('');
        vorige = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        el.hidden = false;
        open = true;
        track.scrollLeft = track.clientWidth * start;
        tel();
        el.querySelector('[data-zoom-dicht]').focus();
      }
    };
  })();

  // Levertijd (Joost 24-10): in NL op werkdagen besteld = morgen in huis; weekend en België 1-2 werkdagen
  function levering(root) {
    var el = root.querySelector('[data-b3-levering]');
    if (!el) return;
    try {
      var dag = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short' }).format(new Date());
      if (dag !== 'Sat' && dag !== 'Sun') el.textContent = 'Gratis verzending · vandaag besteld, morgen in huis (NL)';
    } catch (e) {}
  }

  function Product(root) {
    var D = JSON.parse(root.querySelector('[data-b3-data]').textContent);
    levering(root);
    var staat = { kleur: D.gekozen, aantal: 1, hoes: true, hoesKleur: D.gekozen, hoesZelf: false };
    function hoesVan() { return (D.hoezen && D.hoezen[staat.hoesKleur]) || { naam: D.kleuren[staat.kleur].naam, variant: D.kleuren[staat.kleur].hoes, beschikbaar: D.kleuren[staat.kleur].hoesBeschikbaar, prijs: D.kleuren[staat.kleur].hoesPrijs, beeld: D.kleuren[staat.kleur].hoesBeeld }; }
    var gal = {};
    root.querySelectorAll('.b3-gal').forEach(function (g) { gal[g.getAttribute('data-kleur')] = Galerij(g); });
    // Galerijen van de andere kleuren staan in een <template>; pas invoegen als die kleur gekozen wordt
    function zorgGal(kleur) {
      if (gal[kleur]) return;
      var tpl = root.querySelector('template[data-b3-gal-later="' + kleur + '"]');
      if (!tpl) return;
      var frag = document.importNode(tpl.content, true);
      var el = frag.firstElementChild;
      tpl.parentNode.insertBefore(frag, tpl);
      tpl.remove();
      gal[kleur] = Galerij(el);
    }
    // Alvast klaarzetten bij aanwijzen of aanraken van een kleur, en na het laden op de achtergrond
    root.querySelectorAll('[data-b3-kleur]').forEach(function (b) {
      var vooraf = function () { zorgGal(b.getAttribute('data-b3-kleur')); };
      b.addEventListener('pointerenter', vooraf, { passive: true });
      b.addEventListener('touchstart', vooraf, { passive: true });
      b.addEventListener('focus', vooraf);
    });
    var later = function () { root.querySelectorAll('template[data-b3-gal-later]').forEach(function (tp) { zorgGal(tp.getAttribute('data-b3-gal-later')); }); };
    if (document.readyState === 'complete') setTimeout(later, 4000);
    else window.addEventListener('load', function () { setTimeout(later, 4000); });
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return root.querySelectorAll(s); };

    function totaal() {
      var k = D.kleuren[staat.kleur];
      var som = k.prijs * staat.aantal;
      return staat.aantal === 2 ? som - D.korting : som;
    }
    function teken() {
      var k = D.kleuren[staat.kleur];
      $('[data-b3-kleurnaam]').textContent = k.naam;
      var tk = $('[data-b3-titelkleur]'); if (tk) tk.textContent = k.naam.toLowerCase();
      $('[data-b3-prijs]').textContent = geld(k.prijs);
      $('[data-b3-prijs1]').textContent = geld(k.prijs);
      $('[data-b3-prijs2]').textContent = geld(k.prijs * 2 - D.korting);
      var h = hoesVan();
      // gratis extra hoes: één regel; is die kleur op, dan zeggen we dat en gaat hij niet mee
      var ht = $('[data-b3-hoestekst]');
      if (h.beschikbaar) ht.innerHTML = '<b>Extra hoes in <span data-b3-hoesnaam></span></b> gaat gratis mee';
      else ht.innerHTML = 'De extra hoes in <span data-b3-hoesnaam></span> is even op. Kies een andere kleur.';
      $('[data-b3-hoesnaam]').textContent = h.naam.toLowerCase();
      root.querySelector('.b3-hoes').classList.toggle('is-op', !h.beschikbaar);
      $$('[data-b3-hoeskleur]').forEach(function (b) { var aan = b.getAttribute('data-b3-hoeskleur') === staat.hoesKleur; b.classList.toggle('is-gekozen', aan); b.setAttribute('aria-checked', aan ? 'true' : 'false'); });
      $('[data-b3-knopprijs]').textContent = geld(totaal());
      $('[data-b3-plaknaam]').textContent = (staat.aantal === 2 ? '2x ' : '') + k.naam;
      var pb = $('[data-b3-plakbol]'); if (pb && k.hex) pb.style.setProperty('--k', k.hex);
      $('[data-b3-plakprijs]').textContent = geld(totaal());
      $('[data-b3-hint2]').hidden = staat.aantal !== 2;
      var doos = $('[data-b3-doos]'); if (doos) doos.textContent = (staat.aantal === 2 ? '2 kussens met hoes' : 'kussen met hoes') + (staat.hoes && h.beschikbaar ? ', plus de extra hoes' : '');
      // eerlijke voorraadmelding: alleen als het echt weinig is (grens instelbaar in de sectie)
      var vr = $('[data-b3-voorraad]');
      if (vr) {
        var n = k.voorraad, laag = typeof n === 'number' && n > 0 && n <= D.voorraadGrens;
        vr.hidden = !laag;
        if (laag) $('[data-b3-voorraadtekst]').textContent = 'Nog ' + n + ' op voorraad in ' + k.naam.toLowerCase();
      }
      $$('[data-b3-koop]').forEach(function (b) { b.disabled = !k.beschikbaar; });
      $('[data-b3-knoptekst]').textContent = k.beschikbaar ? 'In winkelwagen' : 'Tijdelijk uitverkocht';
    }
    function kies(kleur, scroll) {
      if (!D.kleuren[kleur]) return;
      staat.kleur = kleur;
      if (!staat.hoesZelf) staat.hoesKleur = kleur;
      zorgGal(kleur);
      $$('.b3-gal').forEach(function (g) { g.hidden = g.getAttribute('data-kleur') !== kleur; });
      $$('[data-b3-kleur]').forEach(function (b) {
        var aan = b.getAttribute('data-b3-kleur') === kleur;
        b.classList.toggle('is-gekozen', aan); b.setAttribute('aria-checked', aan ? 'true' : 'false');
      });
      var g = root.querySelector('.b3-gal[data-kleur="' + kleur + '"]');
      g.querySelectorAll('img[loading="lazy"]').forEach(function (i, n) { if (n < 3) i.loading = 'eager'; });
      gal[kleur].reset();
      teken();
      try {
        if (root.getAttribute('data-pagina') === 'product') {
          history.replaceState(null, '', D.kleuren[kleur].url + location.search.replace(/([?&])kleur=[^&]*/, '$1').replace(/[?&]$/, ''));
          // paginatitel en canonical meenemen naar de gekozen kleur
          var vorige = staat.titelKleur || D.gekozen;
          var oud = vorige && D.kleuren[vorige] && D.kleuren[vorige].titel, nieuw = D.kleuren[kleur].titel;
          if (oud && nieuw && document.title.indexOf(oud) > -1) document.title = document.title.replace(oud, nieuw);
          staat.titelKleur = kleur;
          var can = document.querySelector('link[rel="canonical"]'); if (can) can.href = location.origin + D.kleuren[kleur].url;
        }
        else { var u = new URL(location.href); u.searchParams.set('kleur', kleur); history.replaceState(null, '', u); }
      } catch (e) {}
      if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      meet('bline_kleur_gekozen', { kleur: kleur });
    }
    $$('[data-b3-kleur]').forEach(function (b) { b.addEventListener('click', function () { kies(b.getAttribute('data-b3-kleur')); }); });
    document.querySelectorAll('[data-b3-zet-kleur]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); kies(b.getAttribute('data-b3-zet-kleur'), true); });
    });
    $$('[data-b3-aantal]').forEach(function (b) {
      b.addEventListener('click', function () {
        staat.aantal = Number(b.getAttribute('data-b3-aantal'));
        $$('[data-b3-aantal]').forEach(function (x) { var aan = x === b; x.classList.toggle('is-gekozen', aan); x.setAttribute('aria-checked', aan ? 'true' : 'false'); });
        teken();
      });
    });
    $$('[data-b3-hoeskleur]').forEach(function (b) {
      b.addEventListener('click', function () {
        staat.hoesKleur = b.getAttribute('data-b3-hoeskleur'); staat.hoesZelf = true;
        teken(); meet('bline_hoeskleur_gekozen', { hoes: staat.hoesKleur, kussen: staat.kleur });
      });
    });
    var wissel = $('[data-b3-hoeswissel]'), hkl = $('.b3-hoes__kleuren');
    if (wissel && hkl) wissel.addEventListener('click', function () {
      var open = hkl.hidden; hkl.hidden = !open; wissel.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) meet('bline_hoeskleur_open', { kleur: staat.kleur });
    });

    function koop(knop) {
      var k = D.kleuren[staat.kleur];
      meet('bline_in_winkelwagen', { kleur: staat.kleur, aantal: staat.aantal, hoes: staat.hoes, via: knop.closest('[data-b3-plak]') ? 'plakbalk' : 'knop' });
      var items = [{ id: k.variant, quantity: staat.aantal }];
      var hk = hoesVan();
      if (staat.hoes && hk.beschikbaar) items.push({ id: hk.variant, quantity: 1 });
      var lade = document.querySelector('cart-drawer');
      var secties = lade && typeof lade.getSectionsToRender === 'function' ? lade.getSectionsToRender().map(function (s) { return s.id; }) : [];
      var fout = $('[data-b3-fout]'); fout.hidden = true;
      knop.disabled = true; knop.setAttribute('aria-busy', 'true');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: secties, sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (state) {
          if (lade && typeof lade.renderContents === 'function' && state.sections) {
            lade.classList.remove('is-empty');
            lade.renderContents(state);
          } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
        })
        .catch(function () { fout.hidden = false; })
        .finally(function () { knop.disabled = false; knop.removeAttribute('aria-busy'); });
    }
    $$('[data-b3-koop]').forEach(function (b) { b.addEventListener('click', function () { koop(b); }); });

    var plak = $('[data-b3-plak]'), hoofdknop = $('.b3-knop--groot');
    if (plak && hoofdknop) {
      // zichtbaar zolang de grote knop niet helemaal in beeld is, ook bij binnenkomst: met de hele foto (31-10) valt de knop
      // op de meeste telefoons net onder het eerste scherm, de balk houdt kopen dan binnen één tik
      var wacht = false;
      var plakZet = function () { wacht = false; var r = hoofdknop.getBoundingClientRect(); plak.hidden = (r.top >= 0 && r.bottom <= window.innerHeight); }; // balk zichtbaar zodra de grote knop niet helemaal in beeld is, ook bij binnenkomst (31-10)
      var opnieuw = function () { if (!wacht) { wacht = true; requestAnimationFrame(plakZet); } };
      window.addEventListener('scroll', opnieuw, { passive: true });
      window.addEventListener('resize', opnieuw, { passive: true });
      plakZet();
    }
    var zoek = new URLSearchParams(location.search);
    var q = zoek.get('kleur');
    // advertenties kunnen een keuze uitlichten (?aantal=2, ?hoes=1), maar nooit vooraf aanvinken of kiezen:
    // een betaalde extra optie mag niet standaard aan staan (consumentenregels, ACM)
    if (zoek.get('aantal') === '2') { var b2 = root.querySelector('[data-b3-aantal="2"]'); if (b2) b2.classList.add('is-uitgelicht'); }
    if (zoek.get('hoes') === '1') { var hl = $('.b3-hoes'); if (hl) hl.classList.add('is-uitgelicht'); }
    if (q && D.kleuren[q] && q !== staat.kleur) kies(q); else teken();
  }

  // video pas laden en afspelen na een tik (sneller laden, minder data op mobiel)
  function videos() {
    document.querySelectorAll('[data-b3-speel]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        var v = knop.parentNode.querySelector('video[data-b3-video]');
        if (!v) return;
        if (!v.src) { v.src = v.getAttribute('data-b3-video'); v.controls = true; }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        knop.hidden = true;
      });
    });
  }

  function band() {
    document.querySelectorAll('[data-b3-band]').forEach(function (b) {
      var stop = function () { b.classList.toggle('is-gepauzeerd'); };
      b.addEventListener('click', stop);
      b.addEventListener('keydown', function (e) { if (e.target.closest('a')) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stop(); } });
    });
  }

  function start() {
    band();
    document.querySelectorAll('[data-b3-product]').forEach(Product);
    videos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
